import React from 'react';
import '../less/index.less'
import { Control, Link } from 'MWC';
import { LANG } from '../../../../services/l10n';
import yellow_card_banner from "../img/yellow_card_banner.png";
import howTоGet_img_1 from "../img/how_to_1.png";
import howTоGet_img_2 from "../img/how_to_2.png";
import howTоGet_img_3 from "../img/how_to_3.png";
import Banner from "../../../../auxiliary-components/shared/Banner";
import TabsNew from "../../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../enums/usage_block_data.json";
import DownloadApp from "../../views/downloadApp.c";
import Table from "../../../../auxiliary-components/shared/Table";
import table_data from "../enums/table_data.json";
import share_icon from "../../ProjectSupport/img/share_icon.svg";
import Order from "../../views/orderAction";
import order_yellow_card from "../img/order_yellow_card.png"
import HowToBlock from "../../../../auxiliary-components/shared/HowToBlock";
import download_block_img from "../../../ATB/img/download_block_img.png";
import scrollToOrder from 'utils/scrollToOrder';
import QuestionsAdminBlock from "../../../../auxiliary-components/shared/QuestionsAdmin";
import SliderComponent from "../../../../auxiliary-components/shared/Slider";
import { Preloader } from "MWComponents";


export default function template() {
    const isMobile = this.isViewportMobile(),
        {viewport} = this.props,
        isUtm = this.props.location.search.indexOf('utm_') !== -1,
        modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'tariffs', title: 'GREEN_CARD_NAV_TITLE_2'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
        page = 'yellow-card',
        howToItems = [
            { img: howTоGet_img_1, index: 'first', title: 'YELLOW_HOWTOGET_ITEM_01_TITLE', text: 'YELLOW_HOWTOGET_ITEM_01_TEXT' },
            { img: howTоGet_img_2, title: 'YELLOW_HOWTOGET_ITEM_02_TITLE', text: 'YELLOW_HOWTOGET_ITEM_02_TEXT' },
            { img: howTоGet_img_3, title: 'YELLOW_HOWTOGET_ITEM_03_TITLE',text: 'YELLOW_HOWTOGET_ITEM_03_TEXT' }
        ],
        tariffsGreen =
            this.props.lang === LANG.UA
                ? 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ua.pdf'
                : 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ru.pdf',

        termsAndConditions = 'https://conditions-and-rules.a-bank.com.ua/main/view-content-493/?lang=uk',
        model = this.getModel(),

        orderCards = (
            <div className="card-order-wrapper" id='order'>
                <div className="left-side">
                    <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                    <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                    <div className="card-order">
                        <div className="order-wrapper green-card">
                            <Order
                                {...this.props}
                                row={!this.isViewportMobile()}
                                utmParams={this.utmParams}
                                type="yellow"
                            />
                        </div>
                    </div>
                </div>
                <img className="order-img" alt=" " src={order_yellow_card}></img>
            </div>
        ),
        app = isMobile && isUtm ?
          (
            <div className="content">
              {orderCards}
            </div>
          )
          :
          (<div className="download-app-wrapper" id='order'>
            <DownloadApp {...this.props} />
          </div>);

    return (
        <div className="yellow-card">
          <div className='slider-container'>
            {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
          </div>
            <TabsNew modes={modes} isMobile={isMobile} page={'quick-cash'} toggle={this.toggleMode}
                     mode={this.state.mode}>
                <div className="wrapper" type={modes[0].mode}>
                    <div className="content">
                        <UsageBlock isMobile={isMobile} page={page} data={usage_block_data}
                                    className="col-3-row-1"></UsageBlock>
                        <div className="block-title">{this.l10n("YELLOW_CARD_HOW_TO_TITLE")}</div>
                        <HowToBlock data={howToItems} isMobile={isMobile} page={'shoping-atb'}></HowToBlock>
                        {isMobile ? '' : orderCards}
                    </div>
                    {isMobile ? app : ''}
                </div>
                <div className="wrapper" type={modes[1].mode}>
                    <div className="content">
                        <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                        <div className="tariffs-desc" id="425">
                            {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                            <a className="link" href={tariffsGreen} target="_blank">
                                {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                                <img alt="href_img" src={share_icon}></img>
                            </a>
                        </div>
                    </div>
                    {app}
                </div>
                <div className="wrapper" type={modes[2].mode}>
                  <div className="content">
                    <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                  </div>
                    {app}
                </div>
            </TabsNew>

            <div className="documents">
                <div className='content'>
                    <div className="documents-title">{this.l10n('ACQUIRING_LEFT_DOC_TITLE')}</div>
                    <div className="documents-item-wrapper">
                        <Link className="documents-item" href={`${termsAndConditions}`} target="_blank"
                              dangerouslySetInnerHTML={{__html: this.l10n('PLATINUM_DOWNLOADS_ITEM_3')}}>
                        </Link>
                        <Link className="documents-item" href={`${tariffsGreen}`} target="_blank"
                              dangerouslySetInnerHTML={{__html: this.l10n('YELLOW_CARD_DOC_TARIFF_TITLE')}}>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    );
}
